"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _dataModel = _interopRequireDefault(require("./backbone/dataModel"));

var _dataCollection = _interopRequireDefault(require("./backbone/dataCollection"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default =
/*#__PURE__*/
function () {
  function _default() {
    var queriesData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    (0, _classCallCheck2["default"])(this, _default);

    if (!(queriesData instanceof Array)) {
      queriesData = [queriesData];
    }

    this.queriesData = queriesData;
    return this;
  }

  (0, _createClass2["default"])(_default, [{
    key: "query",
    value: function query() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.queriesData) {
        return Promise.reject();
      }

      if (typeof options.beforeSend === 'function') {
        options.beforeSend();
      }

      var _error;

      return Promise.all(this.queriesData.map(function (item) {
        // make Promise from every query
        return new Promise(function (resolve, reject) {
          var method = item.method,
              storage = item.storage; // no storage/method for query

          if (!method || !storage || !storage[method]) {
            reject();
          }

          storage[method].call(storage, _objectSpread({}, item.options || {}, {
            success: function success(data) {
              if (!(storage instanceof _dataModel["default"] || storage instanceof _dataCollection["default"]) && typeof storage.success === 'function') {
                storage.success(data);
              }

              resolve(data);
            },
            error: function error(e) {
              _error = e;
              resolve(e);
            }
          }));
        });
      })).then( // Разруливаем error, success тут
      // для того что бы пул запросов был неблокирующий
      function (data) {
        if (_error) {
          if (typeof options.error === 'function') {
            options.error(_error);
          }
        } else {
          if (typeof options.success === 'function') {
            options.success.apply(options, (0, _toConsumableArray2["default"])(data));
          }
        }

        if (typeof options.complete === 'function') {
          options.complete();
        }

        if (_error) {
          return Promise.reject(_error);
        } else {
          return Promise.resolve.apply(Promise, (0, _toConsumableArray2["default"])(data));
        }
      });
    }
  }]);
  return _default;
}();

exports["default"] = _default;